import { FC } from "react";
import { Box, Separator, Flex, HStack, Text } from "@chakra-ui/react";

import { EVAL_RUN_STATUS, EvalAverageScores } from "@shared/models";
import { getUSFormatedDateTime } from "@shared/utils";
import { EVAL_CRITERIA_ORDER } from "@containers/Evaluation/constants";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import { ScoreBadge } from "../ScoreBadge";
import { EvalRunStatusBadge } from "../../EvalRunStatusBadge";

interface EvalRunDetailHeaderProps {
  uuid: string;
  status: EVAL_RUN_STATUS;
  totalCases: number;
  averageScores: EvalAverageScores;
  createdAt: string;
}

const EvalRunDetailHeader: FC<EvalRunDetailHeaderProps> = ({ uuid, status, totalCases, averageScores, createdAt }) => {
  const scoredCriteria = EVAL_CRITERIA_ORDER.filter((criterion) => averageScores[criterion] !== undefined);

  return (
    <Box bg="white" borderWidth="1px" borderColor="gray.50" borderRadius="8px" p="16px">
      <Flex justify="space-between" align="center" gap="16px" flexWrap="wrap">
        <HStack gap="10px">
          <Text
            fontFamily="mono"
            fontSize="13px"
            fontWeight={FONT_WEIGHT.HEAVY}
            bg="brand.bg"
            px="8px"
            py="2px"
            borderRadius="6px"
          >
            {uuid.slice(0, 8)}
          </Text>
          <Text fontSize="12px" color="brand.grey">
            {totalCases} case{totalCases === 1 ? "" : "s"}
          </Text>
          <EvalRunStatusBadge status={status} />
        </HStack>
        <Text fontSize="12px" color="brand.grey">
          {getUSFormatedDateTime(createdAt)}
        </Text>
      </Flex>

      {status === EVAL_RUN_STATUS.RUNNING && (
        <Text mt="14px" fontSize="12px" color="brand.grey">
          The evaluation is still running. Results will appear here once all cases are scored.
        </Text>
      )}

      {status === EVAL_RUN_STATUS.FAILED && (
        <Text mt="14px" fontSize="12px" color="brand.error">
          The evaluation failed. Please run it again.
        </Text>
      )}

      {!!scoredCriteria.length && (
        <>
          <Separator my="14px" borderColor="gray.50" />
          <Flex gap="8px" flexWrap="wrap">
            {scoredCriteria.map((criterion) => (
              <ScoreBadge key={criterion} criterion={criterion} score={Number(averageScores[criterion]?.toFixed(2))} />
            ))}
          </Flex>
        </>
      )}
    </Box>
  );
};

export default EvalRunDetailHeader;
